export enum PromoContactRole {
  OWNER = 'owner',
  ASSISTANT = 'assistant',
  ADMIN = 'admin',
}
